import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Card from '../components/ui/Card';
import './Login.css';
import logo from '../logo.png';

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  
  const { login, isAuthenticated, loading, error, clearError } = useAuth();
  const navigate = useNavigate();

  // Redirection si déjà connecté
  useEffect(() => {
    if (isAuthenticated && !loading) {
      navigate('/');
    }
  }, [isAuthenticated, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setIsLoading(true);
    clearError();

    try {
      await login(credentials);
    } catch (error) {
      console.error('Erreur connexion:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  if (loading) {
    return (
      <div className="login-container">
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <p className="loading-text">Chargement de votre espace...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <Card className="login-card" padding="xl" borderRadius="xl">
        {/* Header */}
        <div className="login-header">
          <div className="login-logo">
            <div className="logo-icon">
              <img 
                src={logo} 
                alt="Logo Avantagea" 
                className="logo-image"
              />
            </div>
            <div className="logo-text">
              <h1 className="login-title">Avantagea</h1>
              <p className="login-subtitle">Espace Admin</p>
            </div>
          </div>
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              <div className="error-content">
                <strong>Erreur de connexion</strong>
                <p>{error}</p>
              </div>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Identifiant professionnel
            </label>
            <div className="input-container">
              <span className="input-icon">👨‍💼</span>
              <input
                type="text"
                id="username"
                name="username"
                onChange={handleChange}
                placeholder="Votre identifiant"
                required
                disabled={isLoading}
                className="form-input"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Mot de passe
            </label>
            <div className="input-container">
              <span className="input-icon">🗝️</span> 
              <input
                type="password"
                id="password"
                name="password"
                onChange={handleChange}
                placeholder="Votre mot de passe"
                required
                disabled={isLoading}
                className="form-input"
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="button-spinner"></span>
                Connexion en cours...
              </>
            ) : (
              <>
                <span className="button-icon">🚀</span>
                Se connecter
              </>
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="login-footer">
          <div className="security-info">
            <span className="security-icon">🛡️</span>
            <span className="security-text">Connexion sécurisée</span>
          </div>
        </div>
      </Card>

      {/* Background decoration */}
      <div className="login-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>
      </div>
    </div>
  );
};

export default Login;